import {makeStyles} from 'tss-react/mui';

export default makeStyles()(({v2}) => ({
    'app-icon': {
        width: '14px',
        height: '14px',
        fill: v2 ? 'rgba(63, 63, 63, 0.75)' : undefined,
    },
}));
